import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable, map } from 'rxjs';

import { FinnairCompletionStatus, FinnairOrder, FinnairTravelRequirementsEligibility } from '@fcom/dapi/api/models';
import { entrySet } from '@fcom/core/utils';
import { finShare } from '@fcom/rx';

type TravelRequirementWithName = FinnairTravelRequirementsEligibility & { name: string };

@Component({
  selector: 'fin-apis-global-status',
  templateUrl: './apis-global-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ApisGlobalStatusComponent implements OnInit {
  readonly FinnairCompletionStatus = FinnairCompletionStatus;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  order$: Observable<FinnairOrder>;

  isCompleted$: Observable<boolean>;
  travelRequirements$: Observable<TravelRequirementWithName[]>;

  ngOnInit(): void {
    this.travelRequirements$ = this.order$.pipe(
      map((order) =>
        entrySet({ ...order.eligibilities.travelRequirement })
          .map((entry) => ({ ...entry.value, name: entry.key }))
          .filter(({ required }) => required)
      ),
      finShare()
    );
    this.isCompleted$ = this.travelRequirements$.pipe(
      map((travelRequirements) =>
        travelRequirements.every(({ status }) => status === FinnairCompletionStatus.COMPLETED)
      )
    );
  }
}
